// ─────────────────────────────────────────────────────────────────────────────
// OUTFORM CONCEPT 3 — standalone page, deliberately OUTSIDE the React Flow
// board. Added 24 Aug 2026 after the board-embedded version turned out to be
// unclickable: React Flow's own pane sits in the DOM ancestor chain above the
// node content in a way that intercepts pointer events on the step controls,
// confirmed live via a headless click test (elementFromPoint at the button's
// exact coordinates resolved to `.react-flow__pane`, not the button), and
// z-index / explicit sizing did not fix it. Rather than keep fighting React
// Flow's internals, this is the same component rendered on a plain route with
// no canvas at all — nothing to intercept a click.
//
// The board section (BoardPage.tsx, "OUTFORM — CONCEPT 3 (DRAFT)") stays as a
// reference/thumbnail; THIS page is what to actually click through.
// ─────────────────────────────────────────────────────────────────────────────

import { OutformConceptThree } from "./outform-concept3";

export function OutformConceptThreePage() {
  return (
    <div style={{ minHeight: "100vh", background: "#f0f1f3", padding: "40px 24px", display: "flex", flexDirection: "column", alignItems: "center", gap: 24 }}>
      <div style={{ maxWidth: 1710, width: "100%" }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1a1a1a", margin: "0 0 4px" }}>
          Outform — Concept 3: one agent, two ways in
        </h1>
        <p style={{ fontSize: 14, color: "#5c5c5c", margin: "0 0 20px", maxWidth: 900 }}>
          Docked chat for big moves, an inline popover at the selected cells for surgical ones — click through the
          14 steps below with Play, the arrows, or the dots.
        </p>
      </div>
      <OutformConceptThree width={1710} />
    </div>
  );
}

export default OutformConceptThreePage;
